import { NavLink } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import logo from "../assets/logo/logo.jpeg";

type FormNavVariant = "solid" | "soft";

type FormNavProps = {
  counsellorHref?: string;
  logoAlt?: string;
  variant?: FormNavVariant;
};

const DEFAULT_COUNSELLOR_HREF = "https://wa.me/601112870256";

export default function FormNav({
  counsellorHref = DEFAULT_COUNSELLOR_HREF,
  logoAlt = "scs education logo",
  variant = "soft",
}: FormNavProps) {
  const isSolid = variant === "solid";
  const Icon = isSolid ? Phone : MessageCircle;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-3xl mx-auto px-4 h-14 flex items-center justify-between">
        <NavLink to="/" className="flex items-center gap-2">
          <img src={logo} alt={logoAlt} className="w-12 h-12" />
        </NavLink>
        <a
          href={counsellorHref}
          target="_blank"
          rel="noopener noreferrer"
          className={
            isSolid
              ? "flex items-center gap-2 px-4 py-2 rounded-xl bg-green-500 text-white text-[13px] hover:bg-green-600 transition-colors"
              : "flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-green-50 border border-green-200 text-green-700 text-[12px] hover:bg-green-100 transition-colors"
          }
          style={{ fontWeight: isSolid ? 700 : 600 }}
        >
          <Icon className="w-3.5 h-3.5" /> Talk to a Counsellor
        </a>
      </div>
    </header>
  );
}
